import { useCallback, useRef } from 'react';
import { extractJapanPostalCode } from './postal-code';
import { useAtlas } from './use-atlas';
export function useJapanAutocomplete({ isAutocompleteEnabled }) {
    const state = useRef({
        hasAddress: false
    });
    const atlas = useAtlas({
        enabled: isAutocompleteEnabled
    });
    const searchByPostalCode = useCallback(async (text)=>{
        const postalCode = extractJapanPostalCode(text);
        if (!postalCode) {
            return;
        }
        if (state.current.postalCode === postalCode && state.current.hasAddress) {
            return state.current.address;
        }
        state.current = {
            postalCode,
            address: undefined,
            hasAddress: false
        };
        try {
            const address = await atlas?.searchByPostalCode({
                countryCode: 'JP',
                postalCode
            });
            state.current.hasAddress = true;
            state.current.address = undefined;
            if (address?.formattedAddress) {
                state.current.address = address;
                return address;
            }
            return;
        } catch (e) {
            console.error(e);
        }
        return;
    }, [
        atlas
    ]);
    return {
        searchByPostalCode
    };
}

//# sourceMappingURL=use-japan-autocomplete.js.map